import * as React from "react";

import "react-international-phone/style.css";

import { DataTable } from "primereact/datatable";
import { useState } from "react";
import { Column } from "primereact/column";

import { Vehicle } from "../../../../models/vehicle.interface";
import useApiService from "../../../../hooks/useApiService";
import { CancelIcon, CheckIcon } from "../../../../assets/icons";
import { formatCurrency } from "../../../../utils/currenctUtils";
import { formDataType } from "../AddSite";
import styles from "../add-site.module.css";
import { Checkbox } from "../../../../components/Shared/Forms";

interface VehicleProps {
  handleChange: (name: string, value: string[]) => void;
  formData: formDataType;
}

export function Vehicles({ handleChange, formData }: VehicleProps) {
  const [vehicleData, setVehicleData] = useState<Vehicle[]>([]);
  const [selectedVehicles, setSelectedVehicles] = useState<string[]>([]);
  const [rowClick, __] = useState(true);
  const [allSelected, setAllSelected] = useState<boolean>(false);

  function handleSelectionChange(e: Vehicle) {
    const isSelected = selectedVehicles.includes(e.id);

    if (isSelected) {
      setSelectedVehicles(selectedVehicles.filter(vehicle => vehicle !== e.id));
      handleChange(
        "vehicle",
        selectedVehicles.filter(vehicle => vehicle !== e.id)
      );
      return;
    }
    setSelectedVehicles([...selectedVehicles, e.id]);
    handleChange("vehicle", [...selectedVehicles, e.id]);
  }

  const { loading: loadingVehicles } = useApiService<Vehicle[]>({
    url: "vehicle",
    method: "GET",
    apiName: "core",
    onSuccess: data => {
      const selected = data
        .filter(vehicle => formData.vehicle?.includes(vehicle.id))
        .map(vehicle => vehicle.id);
      setSelectedVehicles(selected);
      setVehicleData(data);
    },
  });

  function handleAllSelected() {
    if (!allSelected) {
      setSelectedVehicles(vehicleData.map(item => item.id));
      handleChange(
        "vehicle",
        vehicleData.map(item => item.id)
      );
      return;
    }

    setSelectedVehicles([]);
    handleChange("vehicle", []);
  }

  return (
    <div>
      <p className={"mt-4"}>
        What vehicles will be used on site? This can be updated and expanded once the site is
        created as well.
      </p>
      {loadingVehicles ? (
        <div
          style={{
            width: "100%",
            height: "500px",
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      ) : (
        <>
          {vehicleData.length > 0 ? (
            <>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Checkbox
                  checked={allSelected}
                  onChange={() => {
                    setAllSelected(!allSelected);
                    handleAllSelected();
                  }}
                  label={"Select all"}
                />
              </div>
              <div className={styles["responsive-grid-3"]}>
                {vehicleData.map((vehicle: Vehicle) => {
                  return (
                    <div key={vehicle.id} className={styles["check-item"]}>
                      <Checkbox
                        checked={selectedVehicles.includes(vehicle.id)}
                        label={vehicle.name}
                        onChange={() => handleSelectionChange(vehicle)}
                        disabled={!vehicle.active}
                      />
                      <span>
                        {vehicle.vin_number && `${vehicle.vin_number} | `} {vehicle.type}
                      </span>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div>
              <h3>No vehicles were found!</h3>
            </div>
          )}
        </>
      )}
    </div>
  );
}
